<template>
  <v-app id="dashboard">
    <navigation></navigation>
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>
          <v-col cols="md-4">
            <v-sheet rounded="" outlined class="pa-6" min-height="100%">
              <v-select
                :items="teamsOnly"
                v-model="selected_user"
                :item-text="getFullName"
                item-value="id"
                background-color="grey lighten-3"
                return-object
                flat
                solo
                @change="changeUser"
              ></v-select>
              <v-select
                :items="dates"
                v-model="selected_date"
                label="Solo field"
                background-color="grey lighten-3"
                flat
                solo
                class="mt-n4"
                @change="changeDate"
              ></v-select>

              <v-row class="my-n7" v-if="show_from_to">
                <v-col cols="6">
                  <v-menu
                    v-model="dateMenu"
                    :close-on-content-click="false"
                    :nudge-right="0"
                    lazy
                    transition="scale-transition"
                    full-width
                    min-width="290px"
                    max-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field v-on="on" v-model="from_date" filled readonly background-color="grey lighten-3" solo flat class="">{{
                        from_date
                      }}</v-text-field>
                    </template>
                    <v-date-picker locale="en-in" v-model="from_date" no-title @input="dateMenu = false" @change="changeDate"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6">
                  <v-menu
                    v-model="dateMenuTo"
                    :close-on-content-click="false"
                    :nudge-right="0"
                    lazy
                    transition="scale-transition"
                    full-width
                    min-width="290px"
                    max-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field v-on="on" v-model="to_date" filled readonly background-color="grey lighten-3" solo flat class="">{{
                        to_date
                      }}</v-text-field>
                    </template>
                    <v-date-picker locale="en-in" v-model="to_date" no-title @input="dateMenuTo = false" @change="changeDate"></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>

              <v-divider class="mt-n4 mb-3"></v-divider>

              <v-sheet rounded="" outlined class="px-2" color="grey lighten-3">
                <v-list color="grey lighten-3">
                  <v-list-item-group>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon>mdi-share</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-row v-if="quickStats">
                          <v-col cols="3" class="text-right">{{ quickStats.campaigns_created }}</v-col
                          ><v-col class="text-left">Empfehlungslinks</v-col>
                        </v-row>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon>mdi-eye</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-row v-if="quickStats">
                          <v-col cols="3" class="text-right">{{ quickStats.views }}</v-col
                          ><v-col class="text-left">Profilansichten</v-col>
                        </v-row>
                        <!-- <v-list-item-title v-if="quickStats"
                          v-text="quickStats.views + ' Profilansichten'"
                        ></v-list-item-title> -->
                      </v-list-item-content>
                    </v-list-item>

                    <!-- <v-list-item>
                      <v-list-item-icon>
                        <v-icon>mdi-phone</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-row v-if="quickStats">
                          <v-col cols="3" class="text-right">{{ quickStats.contacts }}</v-col
                          ><v-col class="text-left">Kontaktanfragen</v-col>
                        </v-row>
                      </v-list-item-content>
                    </v-list-item> -->

                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon>mdi-heart</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-row v-if="quickStats">
                          <v-col cols="3" class="text-right">{{ quickStats.likes }}</v-col
                          ><v-col class="text-left">Likes</v-col>
                        </v-row>
                        <!-- <v-list-item-title v-if="quickStats"  
                          v-text="quickStats.likes + ' Likes'"
                        ></v-list-item-title> -->
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-sheet>
            </v-sheet>
          </v-col>

          <!-- Users -->
          <v-col v-if="isTeam == true">
            <v-sheet min-height="100%" rounded="" outlined class="pa-6">
              <h4 class="py-2">Team Statistik</h4>
              <v-divider></v-divider>
              <v-simple-table>
                <template v-slot:default>
                  <!-- <thead>
                    <tr>
                      <th class="text-left">Name</th>
                      <th class="text-left"></th>
                      <th class="text-left"></th>
                      <th class="text-left"></th>
                      <th class="text-left"></th>
                    </tr>
                  </thead> -->
                  <tbody>
                    <tr v-for="user in users" :key="user.id">
                      <td class="pl-0 text-body-1">{{ getFullName(user) }}</td>

                      <td class="text-caption text-right px-0" width="6%"><v-icon class="mr-1" size="1.2rem">mdi-share</v-icon></td>
                      <td class="text-caption px-0" width="6%">{{ user.stats.campaigns_created }}</td>

                      <td class="text-caption text-right px-0" width="6%"><v-icon class="mr-1" size="1.2rem">mdi-eye</v-icon></td>
                      <td class="text-caption px-0" width="6%">{{ user.stats.views }}</td>

                      <!-- <td class="text-caption text-right px-0" width="6%"><v-icon class="mr-1" size="1.2rem">mdi-phone</v-icon></td>
                      <td class="text-caption px-0" width="6%">{{ user.stats.contacts }}</td> -->

                      <td class="text-caption text-right px-0" width="6%"><v-icon class="mr-1" size="1.2rem">mdi-heart</v-icon></td>
                      <td class="text-caption px-0" width="6%">{{ user.stats.likes }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-sheet>
          </v-col>

          <!-- User Campaigns -->
          <v-col v-if="isTeam == false">
            <v-sheet min-height="100%" rounded="lg" outlined class="pa-6">
              <h4 class="py-2">Interaktionen im Zeitraum von {{ from_date }} bis {{ to_date }}</h4>
              <v-divider></v-divider>
              <v-simple-table>
                <template v-slot:default>
                  <!-- <thead>
                    <tr>
                      <th class="text-left">Name</th>
                      <th class="text-left"></th>
                      <th class="text-left"></th>
                      <th class="text-left"></th>
                      <th class="text-left"></th>
                    </tr>
                  </thead> -->
                  <tbody>
                    <tr v-for="campaign in member.campaigns" :key="campaign.id">
                      <td class="text-body-1 px-0">{{ campaign.name }}</td>
                      <td class="text-caption text-right px-0" width="6%"><v-icon class="mr-1" size="1.2rem">mdi-eye</v-icon></td>
                      <td class="text-caption px-0" width="6%">{{ campaign.stats.views }}</td>

                      <!-- <td class="text-caption text-right px-0" width="6%"><v-icon class="mr-1" size="1.2rem">mdi-phone</v-icon></td>
                      <td class="text-caption px-0" width="6%">{{ campaign.stats.contacts }}</td> -->

                      <td class="text-caption text-right px-0" width="6%"><v-icon class="mr-1" size="1.2rem">mdi-heart</v-icon></td>
                      <td class="text-caption px-0" width="6%">{{ campaign.stats.likes }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-sheet>
          </v-col>
        </v-row>

        <v-row>
          <!-- contact box -->
          <v-col cols="md-4">
            <v-sheet rounded="" outlined class="pa-6">
              <!-- <v-container> -->
              <v-row>
                <v-col>
                  <h4 class="mb-2">Brauchst du Unterstützung?</h4>
                  <v-divider></v-divider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <v-avatar size="80" class="">
                    <img v-if="trainer.avatar_src" :src="trainer.avatar_src" :alt="trainer.first_name + ' ' + trainer.last_name + ' avatar image'" />
                    <img v-else src="../assets/wocodea_logo_short.png" :alt="trainer.first_name + ' ' + trainer.last_name + ' avatar image'" />
                  </v-avatar>
                </v-col>
                <v-col>
                  <h4 class="pl-3">Kontaktiere {{ trainer.first_name }}</h4>
                  <p class="pl-3 caption text--secondary">Team Trainer</p>
                </v-col>
              </v-row>
              <v-row>
                <v-divider></v-divider>
              </v-row>
              <v-row>
                <v-col>
                  <ul style="list-style: none" class="pl-0">
                    <li class="py-2">
                      <v-btn style="border-radius: 5px" small color="primary" icon outlined><v-icon>mdi-account</v-icon></v-btn>
                      <a class="ml-3 h4 grey--text text--darken-4 text-decoration-none font-weight-bold" target="_blank" :href="trainer.public_profile_url"
                        >Wocodea Profil öffnen</a
                      >
                    </li>
                    <li class="py-2">
                      <v-btn style="border-radius: 5px" small color="primary" icon outlined v-if="trainer.phone && trainer.phone.length > 0"
                        ><v-icon>mdi-phone</v-icon></v-btn
                      >
                      <a class="ml-3 h4 grey--text text--darken-4 text-decoration-none font-weight-bold" :href="'tel:' + trainer.phone">{{ phoneMask }}</a>
                    </li>
                  </ul>
                </v-col>
              </v-row>
              <v-row
                ><v-col>
                  <v-btn color="primary" width="100%" depressed href="mailto:"> ❤ Empfehle Wocodea weiter</v-btn>
                </v-col></v-row
              >
              <!-- </v-container>   -->
            </v-sheet>
          </v-col>

          <!-- messages box -->
          <v-col cols="md-8">
            <v-sheet rounded="" outlined class="pa-6" min-height="100%">
              <v-row>
                <v-col>
                  <h4 class="mb-2">Team Kommunikation</h4>
                  <v-divider></v-divider>
                </v-col>
              </v-row>
              <v-row v-if="displayPushSuccess == true" class="pt-6">
                <v-col align="center">
                  <v-icon color="success" size="3rem" class="ma-4">mdi-check-all</v-icon>
                  <br />
                  Nachricht erfolgreich versendet.
                  <br />
                  <v-btn
                    color="primary"
                    @click="
                      displayPushSuccess = false;
                      displayPushControls = true;
                    "
                    class="ma-6"
                    depressed
                    >Alles klar</v-btn
                  >
                </v-col>
              </v-row>
              <v-row v-if="displayPushError == true" class="pt-6">
                <v-col align="center">
                  <v-icon color="error" size="3rem" class="ma-4">mdi-alert</v-icon>
                  <br />
                  Fehler beim Senden der Nachricht
                  <br />
                  <v-btn
                    color="primary"
                    @click="
                      displayPushError = false;
                      displayPushControls = true;
                    "
                    class="ma-6"
                    depressed
                    >Alles klar</v-btn
                  >
                </v-col>
              </v-row>

              <v-row v-if="displayPushControls == true">
                <v-col cols="6">
                  <span class="caption"><strong>Schreibe an</strong></span>
                  <v-combobox
                    v-model="selected_push_users"
                    :items="users"
                    :item-text="getFullName"
                    label="Team Mitglieder"
                    multiple
                    chips
                    solo
                    flat
                    color="grey lighten-3"
                    background-color="grey lighten-3"
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        :key="JSON.stringify(data.item)"
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        :disabled="data.disabled"
                        @click:close="data.parent.selectItem(data.item)"
                        color="white"
                      >
                        <v-avatar class="primary white--text" left v-text="data.item.first_name.slice(0, 1).toUpperCase()"></v-avatar>
                        {{ data.item.first_name + " " + data.item.last_name }}
                      </v-chip>
                    </template>
                  </v-combobox>
                </v-col>
                <v-col cols="6">
                  <span class="caption"><strong>Push Notificaftion</strong></span>
                  <v-textarea
                    v-model="push_contents"
                    width="100%"
                    solo
                    flat
                    outlined
                    label="Informiere oder motiviere dein Team..."
                    class="text-body-2"
                    color="grey lighten-2"
                    counter="160"
                    rows="5"
                  ></v-textarea>
                  <v-btn color="primary" width="50%" depressed @click="sendPushNotification">Senden</v-btn>
                </v-col>
              </v-row>
            </v-sheet>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import moment from "moment";
import Navigation from "./Navigation.vue";

const CURRENT_WEEK = "Aktuelle Woche";
const CURRENT_MONTH = "Aktueller Monat";
const PREVIOUS_WEEK = "Vorige Woche";
const PREVIOUS_MONTH = "Voriger Monat";
const CUSTOM = "Benutzerdefiniert";

export default {
  components: { Navigation },
  data: () => ({
    links: [
      { href: "/", name: "Dashboard" },
      { href: "members", name: "Team Mitglieder" },
      { href: "login", name: "Logout" },
    ],

    dummyTeam: { id: 0, first_name: "Team", last_name: "Statistik", avatar_src: "" },
    selected_user: { id: 0, first_name: "Team", last_name: "Statistik", avatar_src: "" },
    selected_push_users: [],
    displayPushControls: true,
    displayPushSuccess: false,
    displayPushError: false,
    push_contents: "",
    dates: [CURRENT_WEEK, CURRENT_MONTH, PREVIOUS_WEEK, PREVIOUS_MONTH, CUSTOM],
    dateMenu: false,
    dateMenuTo: false,
    selected_date: CURRENT_WEEK,
    from_date: moment()
      .startOf("isoWeek")
      .format("YYYY-MM-DD"),
    to_date: moment()
      .endOf("isoWeek")
      .format("YYYY-MM-DD"),
    show_from_to: false,
    isTeam: true,
  }),
  computed: {
    team() {
      return this.$store.getters.team;
    },
    users() {
      return this.$store.getters.members;
    },
    member() {
      return this.$store.getters.member;
    },
    trainer() {
      if (this.$store.getters.team.trainer) {
        return this.$store.getters.team.trainer;
      } else {
        // fallback to markus if no trainer defined
        let defaultTrainer = {
          first_name: "Markus",
          last_name: "Nagl",
          avatar_src: "https://wocodea.com/assets/dist/assets/images/markus-nagl.png",
          public_profile_url: "https://wocodea.com/profile/2303103",
          phone: "",
        };

        return defaultTrainer;
      }
    },
	teamsOnly() {
		let all = [this.dummyTeam];
		all.push({ divider: true });

		/*
		if (this.users && this.users.length > 0) {
			console.log("loaded users");
			all.push(...this.users);
		} else {
			console.log("users not loaded yet");
		}
		*/
		return all;

	} ,
    membersAndTeam() {
      let all = [this.dummyTeam];
      all.push({ divider: true });

      if (this.users && this.users.length > 0) {
        console.log("loaded users");
        all.push(...this.users);
      } else {
        console.log("users not loaded yet");
      }
      return all;
    },
    adaptiveHeight() {
      if (this.selected_date == "Benutzerdefiniert") {
        return "52vh";
      } else {
        return "44.5vh";
      }
    },
    quickStats() {
      if (this.isTeam) {
        return this.$store.getters.team.stats;
      } else {
        return this.$store.getters.member.stats;
      }
    },
    // campaigns () {
    //   return this.$store.getters.member.campaigns
    // },
    phoneMask() {
      return this.trainer.phone.replace(/(\d{2})(\d{3})(\d{2})/, "$1 $2 $3");
    },
  },
  async mounted() {
    this.loading = true;
	this.selectionFromLocalStorage();

    console.log("dashboard mounted: loading team");
    let date_range = { from: this.from_date, to: this.to_date };
    await this.$store.dispatch("getTeam", date_range);

    this.loading = false;
  },
  methods: {
    getFullName(item) {
      if (item.first_name && item.last_name) {
        return item.first_name + " " + item.last_name;
      } else {
        return item.name;
      }
    },

    async changeUser(item) {
      if (item.id == 0) {
        // console.log('seleted team')
        this.isTeam = true;
      } else {
        // console.log('seleted user')
        this.isTeam = false;
        this.selected_user = this.users.filter((user) => user.id == item.id)[0];

        try {
          await this.$store.dispatch("getMember", { id: this.selected_user.id, from: this.from_date, to: this.to_date });
        } catch (error) {
          console.error(error);
        }
        this.selectionToLocalStorage();
      }
    },
    async changeDate() {
      switch (this.selected_date) {
        case CURRENT_WEEK:
          this.from_date = moment()
            .subtract(0, "week")
            .startOf("isoWeek")
            .format("YYYY-MM-DD");
          this.to_date = moment()
            .subtract(0, "week")
            .endOf("isoWeek")
            .format("YYYY-MM-DD");
          // console.log('from: ', this.from_date, ' to: ', this.to_date)
          this.show_from_to = false;
          break;
        case CURRENT_MONTH:
          this.from_date = moment()
            .subtract(0, "month")
            .startOf("month")
            .format("YYYY-MM-DD");
          this.to_date = moment()
            .subtract(0, "month")
            .endOf("month")
            .format("YYYY-MM-DD");
          console.log("from: ", this.from_date, " to: ", this.to_date);
          this.show_from_to = false;
          break;
        case PREVIOUS_WEEK:
          this.from_date = moment()
            .subtract(1, "week")
            .startOf("isoWeek")
            .format("YYYY-MM-DD");
          this.to_date = moment()
            .subtract(1, "week")
            .endOf("isoWeek")
            .format("YYYY-MM-DD");
          console.log("from: ", this.from_date, " to: ", this.to_date);
          this.show_from_to = false;
          break;
        case PREVIOUS_MONTH:
          this.from_date = moment()
            .subtract(1, "month")
            .startOf("month")
            .format("YYYY-MM-DD");
          this.to_date = moment()
            .subtract(1, "month")
            .endOf("month")
            .format("YYYY-MM-DD");
          console.log("from: ", this.from_date, " to: ", this.to_date);
          this.show_from_to = false;
          break;
        case CUSTOM:
          console.log("from: ", this.from_date, " to: ", this.to_date);
          this.show_from_to = true;
      }

      try {
        if (this.selected_user.id != 0) await this.$store.dispatch("getMember", { id: this.selected_user.id, from: this.from_date, to: this.to_date });
        if (this.selected_user.id == 0) await this.$store.dispatch("getTeam", { from: this.from_date, to: this.to_date });
      } catch (error) {
        console.error("ERROR sending push notification: " + error);
      }

      this.selectionToLocalStorage();

    },
    async sendPushNotification() {
      try {
        let push_notification = {
          message: this.push_contents,
          users: this.selected_push_users,
        };
        await this.$store.dispatch("sendPush", push_notification);
        this.push_contents = null;
        this.selected_push_users = null;
        this.displayPushSuccess = true;
        this.displayPushControls = false;
      } catch (error) {
        console.error("ERROR sending push notification: " + error);
        this.displayPushError = true;
        this.displayPushControls = false;
      }
    },
    selectionToLocalStorage()
    {
      localStorage.setItem('selected_user', JSON.stringify(this.selected_user));
      localStorage.setItem('selected_date', this.selected_date);
      localStorage.setItem('from_date', this.from_date);
      localStorage.setItem('to_date', this.to_date);
	  // {{ dateMenu }} {{ dateMenuTo }} {{ from_date }} {{ to_date }}
      // localStorage.setItem('show_from_to', this.show_from_to);
    },
    selectionFromLocalStorage()
    {
      console.log('recovering');
      if(localStorage.getItem('selected_user')) this.selected_user = JSON.parse(localStorage.getItem('selected_user'));
      if(localStorage.getItem('selected_date')) this.selected_date = localStorage.getItem('selected_date');
      if(localStorage.getItem('from_date')) this.from_date = localStorage.getItem('from_date');
      if(localStorage.getItem('to_date')) this.to_date = localStorage.getItem('to_date');
	  if(this.selected_date===CUSTOM) {
		this.show_from_to = true;
	  }
    }
  },
};
</script>
